<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize" :cStyle="'border-radius: 5px !important;'">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="hostWrapper">
          <Tabs v-if="!isAdding" v-model="currentTab" :tabs="tabs" @change="setTab" />
          <InvoiceAdd v-if="isAdding" ref="invoiceAdd" :firm="firm" @changed="changed" @uploaded="fileUploaded" />
          <div v-if="!isAdding" class="row">
            <div class="col">
              <InvoiceHeader ref="invoiceHeader" :total="invoiceTotal" />
            </div>
          </div>
          <div v-if="!isAdding && currentTab === 'Summary'" class="row mt-2">
            <div class="col">
              <InvoiceSummary ref="invoiceSummary" />
            </div>
          </div>
          <div v-if="!isAdding && !isAnalyzing && currentTab === 'Invoice'" class="row mt-1">
            <div class="col">
              <InvoiceAnalysis ref="invoiceAnalysis" :url="fileUrl" :pages="invoicePages" :tables="invoiceTables" :rendered-tables="renderTables" />
            </div>
          </div>
          <div v-if="!isAdding && currentTab === 'Tables'" class="row">
            <div class="col pt-2">
              <InvoiceReview ref="invoiceReview" :firm="firm" @saved="invoiceSaved" />
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="id">{{ ids }}</span>
          </div>
          <div class="col-3">
            <router-link to="/extension">Get the Invoices AI Chrome Extension Here</router-link>
          </div>
          <div class="col">
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(false)">
              <span class="ms-2">Save</span>
            </button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(true)">
              <span class="ms-2">Save & Close</span>
            </button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { invoiceStore } from '@/stores/invoice'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import Tabs from '@/components/utilities/elements/Tabs.vue'
import InvoiceAdd from './InvoiceAdd.vue'
import InvoiceHeader from './InvoiceHeader.vue'
import InvoiceSummary from './InvoiceSummary.vue'
import InvoiceReview from './InvoiceReview.vue'
import InvoiceAnalysis from './InvoiceAnalysis.vue'
export default {
  name: 'DialogInvoice',
  components: {
    ZDialog,
    ZMessage,
    Tabs,
    InvoiceAdd,
    InvoiceHeader,
    InvoiceSummary,
    InvoiceReview,
    InvoiceAnalysis
  },
  props: {
    modelValue: Object,
    showFirm: Object
  },
  data() {
    return {
      currentTab: 'Invoice',
      isSave: false,
      message: null,
      isSaving: false,
      isAdding: false,
      title: 'Adding Invoice',
      pageWidth: 8.2639,
      pageHeight: 11.6806,
      invoiceTotal: 0
    }
  },
  mounted() {
    this.currentTab = 'Invoice'
    this.resetCells()
  },
  emits: ['closing', 'saved', 'analyzed'],
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(invoiceStore, ['loading', 'invoice', 'invoicePages', 'invoiceTables', 'renderTables']),
    isVisible() {
      this.setView()
      return this.modelValue !== null
    },
    modalSize() {
      let _size = 'modal-xl'
      if (!this.isAdding) {
        _size = 'max'
      }
      return _size
    },
    tabs() {
      let _tabs = ['Summary', 'Invoice', 'Tables']
      return _tabs
    },
    ids() {
      let _ids = ''
      if (this.invoice) {
        if (this.invoice.invoice) {
          _ids = `${this.invoice.invoice}`
        }
      }
      return _ids
    },
    firm() {
      let _id = null
      if (this.invoice) {
        _id = this.invoice.firm
      }
      return _id
    },
    ronumber() {
      let _ronumber = null
      if (this.invoice) {
        _ronumber = this.invoice.ronumber
      }
      return _ronumber
    },
    fileUrl() {
      let _url = null
      if (this.invoice) {
        _url = this.invoice.url
      }
      return _url
    },
    isAnalyzing() {
      let _is = false
      if (this.loading) {
        _is = this.loading.analysis
      }
      return _is
    }
  },
  methods: {
    ...mapActions(invoiceStore, ['resetCells', 'setInvoice', 'analyzeInvoice', 'getInvoice', 'updateInvoice']),
    close() {
      this.isSave = false
      this.currentTab = 'Invoice'
      this.$emit('closing')
    },
    setTab(value) {
      this.resetCells()
      this.currentTab = value
    },
    saved() {
      this.isSave = false
      this.isSaving = false
    },
    setView() {
      this.isAdding = false
      if (this.modelValue) {
        if (this.modelValue.isAdd) {
          this.title = 'Adding Invoice'
          this.isAdding = true
        } else {
          this.title = `Editing Invoice #${this.invoice.invoice} - RO #${this.invoice.ronumber}`
          this.isAdding = false
        }
      }
    },
    changed() {
      this.isSave = true
    },
    async fileUploaded(url) {
      this.isAdding = false
      this.title = 'Editing Invoice'
      this.$forceUpdate()
      this.$emit('analyzing')
      let data = {
        firm: this.firm,
        ronumber: this.ronumber,
        url: url,
        analysis: null,
        analyzedBy: this.profile.user,
        status: null
      }
      let id = await this.analyzeInvoice(data)
      await this.getInvoice(id)
      this.captureInvoiceNumber()
      this.$refs.invoiceAnalysis.init()
      this.$emit('analyzed')
    },
    async captureInvoiceNumber() {
      let data = {
        invoice: this.invoice.invoice,
        firm: this.firm,
        ronumber: this.ronumber,
        vendorName: null,
        invoiceNumber: null,
        status: null
      }
      if (this.invoice) {
        if (this.invoice.analysis) {
          if (this.invoice.analysis.Value.Documents.length > 0) {
            let _doc = this.invoice.analysis.Value.Documents[0]
            if (_doc.Fields) {
              if (_doc.Fields.InvoiceId) {
                data.invoiceNumber = _doc.Fields.InvoiceId.Content
              }
              if (_doc.Fields.VendorName) {
                data.vendorName = _doc.Fields.VendorName.Content
              }
            }
          }
        }
        console.log('Capture Invoice Number:', {
          invoice: this.invoice,
          data: data
        })
        await this.updateInvoice(data)
      }
    },
    invoiceSaved() {
      this.$emit('analyzed')
    },
    async save(closeIt) {
      this.message = null
      let response = null
      this.isSaving = true
      // Save Here
      this.isSaving = false
      this.isSave = false
      if (response.valid) {
        this.isSave = false
        this.$emit('saved', response)
        if (closeIt) {
          this.currentTab = 'Summary'
          this.$emit('closing')
        }
      } else {
        this.message = response.msg
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-right-align {
  text-align: right;
}
.hostWrapper {
  max-height: 100% !important;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
